<template>
  <div class="card card-custom">
    <div class="p-0">
      <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
        <div class="col-xl-12 col-xxl-12">
          <h2 class="text-center pb-10">{{ $t('editMultipleUserRights.title') }}</h2>
          
          <div class="mb-8">
            <h5 class="section-title mb-4">
              <v-icon class="mr-2" color="#e4057d">mdi-account-group</v-icon>
              {{ $t('editMultipleUserRights.selectedUsers') }}
            </h5>
            <v-simple-table class="simple-table">
              <thead>
                <tr>
                  <th>{{ $t('editMultipleUserRights.name') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="ur in userRights" :key="ur.id">
                  <td>{{ ur.name }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>

          <UserRightMultipleThemeTable 
            v-model="userRights" 
            @submit="submit"
          />

          <div class="submit-container mt-4">
            <v-btn class="float-right" color="primary" @click="submit">
              {{ $t('editMultipleUserRights.validateBtn') }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import UserRightMultipleThemeTable from "@/components/admin/userRight/forms/tabs/userRightMultipleThemeTable.vue";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";

export default {
  name: "editUserRight",
  components: { UserRightMultipleThemeTable },
  data: () => ({
    userRights: [],
    themes: [],
  }),

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration", route: "gestionClients" },
      { title: "Gestion des comptes droits utilisateurs", route: "gestionClients" },
      { title: this.$t('editMultipleUserRights.title') },
    ]);

    var userRightsIds = this.$route.params.ids.split(',');
    var userRightsData = this.$route.params.userRights;

    if (userRightsData && userRightsData.length) {
      this.populateUserRightForm(userRightsData);
    } else {
      Promise.all(
        userRightsIds.map(id =>
          Api.get(`/user_rights/${id}`).then(response => response.data)
        )
      ).then(results => {
        this.userRights = results;
      });
    }
  },
  
  methods: {
    submit: async function() {
      try {
        for (const ur of this.userRights) {
          await Api.put(`user_rights/${ur.id}`, {
            name: ur.name,
            comment: ur.comment,
            themes: ur.themes.map(t => t['@id']),
          });
        }

        Swal.fire({
          title: "",
          text: this.$t('editMultipleUserRights.successUpdate'),
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
        });

        this.$router.push({
          name: "gestionClients",
          query: { selected: "tab-userRights" },
        });
      } catch (error) {
        console.error(error);
        Swal.fire({
          title: "",
          text: this.$t('editMultipleUserRights.errorUpdate'),
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
      }
    },

    populateUserRightForm(userRights) {
      this.userRights = userRights.map(ur => ({ ...ur }));
    },
  },
};
</script>

<style scoped>
.card-custom {
  box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05);
  border: 0;
  border-radius: 6px;
}

.section-title {
  font-weight: 600;
  color: #2c3e50;
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.simple-table {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  overflow: hidden;
}

.simple-table >>> thead tr th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #2c3e50;
  border-bottom: 2px solid #dee2e6;
}

.simple-table >>> tbody tr:hover {
  background-color: #f5f5f5;
}

.simple-table >>> tbody tr td {
  padding: 12px 16px;
}

.simple-table >>> thead tr th {
  padding: 12px 16px;
}
</style>